import { api } from './api';
import type { Task, CreateTaskInput, TaskPriority, TaskStatus } from '@traaker/shared';

export const tasksApi = {
  list: (brandId?: string) => {
    const params = brandId ? `?brandId=${brandId}` : '';
    return api.get<Task[]>(`/tasks${params}`);
  },

  getById: (taskId: string) =>
    api.get<Task>(`/tasks/${taskId}`),

  create: async (input: CreateTaskInput & { brandId?: string }) => {
    // The row is created instantly (no guide). Immediately kick off guide
    // generation as a separate, non-awaited request so the "Comment faire ?"
    // guide is warm by the time the user opens the task (one click, no wait).
    // Each call is its own Lambda invocation — a background promise inside the
    // create handler would be frozen once its response returns, so the warm-up
    // must be a distinct HTTP call from here. generateGuide is idempotent, so a
    // detail-open that beats this just picks up the in-flight/finished result.
    const task = await api.post<Task>('/tasks', input);
    void tasksApi.generateGuide(task.taskId).catch(() => {});
    return task;
  },

  updateStatus: (taskId: string, status: TaskStatus) =>
    api.patch<Task>(`/tasks/${taskId}/status`, { status }),

  update: (taskId: string, updates: { priority?: TaskPriority; assigneeId?: string; dueDate?: string }) =>
    api.patch<Task>(`/tasks/${taskId}`, updates),

  delete: (taskId: string) =>
    api.delete<{ success: boolean }>(`/tasks/${taskId}`),

  verify: (taskId: string) =>
    api.post<Task>(`/tasks/${taskId}/verify`, {}),

  /** Lazily generate the "Comment faire ?" guide (called on task-detail open). */
  generateGuide: (taskId: string) =>
    api.post<Task>(`/tasks/${taskId}/generate-guide`, {}),
};
